//#region Styles
import {
    Column, 
    Part, 
    TitleSection, 
    Fields
} from "components/styles";
//#endregion
//#region Components
import HandlerRadio from "components/CustomRadio/CustomRadio";
import NotificationNoContent from "components/NotificationNoContent/NotificationNoContent";
import ZoomControls from "./components/ZoomControls/ZoomControls";
import PlaceControls from "./components/PlaceControls/PlaceControls";
//#endregion

const Part3 = ({
    dataRelatedToForm,
    form, changeField, 
    errors, errorTexts, 
    teacherZoomAccountDetail, 
    // fillTeacherZoomAccountDetail
}) => {
    const {
        locations
    } = dataRelatedToForm;
    //#region Functions
    const changeLocationId = (value) => {
        changeField("locationId", value, false);
    }
    const changePlace = (field, value, errorValue) => {
        changeField("place", prev => ({
            ...prev,
            [field]: typeof value === "function" ? value(prev[field]) : value
        }), prev => ({
            ...prev,
            [field]: typeof errorValue === "function" ? errorValue(prev[field]) : errorValue
        }));
    }
    //#endregion
    const { locationId, place } = form;
    return (
        <Part>
            <Fields>
                <Column gap="20px">
                    <TitleSection>Ubicación:</TitleSection>
                    <HandlerRadio
                        value={locationId}
                        onChange={changeLocationId}
                        radiosProps={
                            locations.map(({ 
                                    id, 
                                    name,
                                    icon 
                                }) => ({
                                value: id, 
                                label: name,
                                icon: <img src={icon} alt={name}/>
                            }))
                        }
                        error={errors.locationId}
                        errorText={errorTexts?.location || "Es necesario seleccionar una ubicación."}/>
                    {locationId === 1 
                    ? <ZoomControls 
                        dataRelatedToForm={dataRelatedToForm}
                        form={form} changeField={changeField}
                        errors={errors} errorTexts={errorTexts}
                        teacherZoomAccountDetail={teacherZoomAccountDetail}/>
                    : locationId === 2 
                    ? <PlaceControls 
                        dataRelatedToForm={dataRelatedToForm}
                        form={place}
                        changeField={changePlace}
                        errors={errors}/>
                    : <NotificationNoContent
                        title="Aún no has señalado una ubicación"
                        description="Selecciona una para mostrarte las opciones de cómo asistir al refuerzo"/> }
                </Column>
            </Fields>
        </Part>
    );
}

export default Part3;